import styled from 'styled-components';

const Options = styled.ul`
  margin: ${props => {
    if (props.variant === 'rate' && !props.selected)
      return '0 auto 1em auto !important';
    if (props.variant === 'rate' && props.selected)
      return '0 auto 0 auto !important';
    return '2px 0 12px 0 !important';
  }};
  padding: ${props => (props.variant === 'rate' ? '0' : '0 6px')};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Options;